import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/lib/auth';
import { loadBranding } from '@/lib/branding';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import AcceptInvite from '@/pages/AcceptInvite';
import Dashboard from '@/pages/Dashboard';
import Devices from '@/pages/Devices';
import DeviceTimeline from '@/pages/DeviceTimeline';
import Employees from '@/pages/Employees';
import Policies from '@/pages/Policies';
import Alerts from '@/pages/Alerts';
import Screenshots from '@/pages/Screenshots';
import Recordings from '@/pages/Recordings';
import ProductivityAnalytics from '@/pages/ProductivityAnalytics';
import GitAnalytics from '@/pages/GitAnalytics';
import AIAnalytics from '@/pages/AIAnalytics';
import AuditLogs from '@/pages/AuditLogs';
import RemoteSessions from '@/pages/RemoteSessions';
import Enrollment from '@/pages/Enrollment';
import UsersPage from '@/pages/Users';
import EmployeeDetail from '@/pages/EmployeeDetail';
import RiskDashboard from '@/pages/RiskDashboard';
import Reports from '@/pages/Reports';
import Teams from '@/pages/Teams';

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  useEffect(() => { loadBranding(); }, []);

  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="devices" element={<Devices />} />
            <Route path="devices/:id" element={<DeviceTimeline />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employees/:id" element={<EmployeeDetail />} />
            <Route path="policies" element={<Policies />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="screenshots" element={<Screenshots />} />
            <Route path="recordings" element={<Recordings />} />
            <Route path="analytics/productivity" element={<ProductivityAnalytics />} />
            <Route path="analytics/git" element={<GitAnalytics />} />
            <Route path="analytics/ai" element={<AIAnalytics />} />
            <Route path="analytics/risk" element={<RiskDashboard />} />
            <Route path="reports" element={<Reports />} />
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="remote-sessions" element={<RemoteSessions />} />
            <Route path="enrollment" element={<Enrollment />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="teams" element={<Teams />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
